import React from 'react';
import { useTranslation } from 'react-i18next';
import { GameContext } from '../../core/context/game.context';
import './ErrorBar.style.scss';

export default function ErrorBar({ errors, updateTo }: { errors: number; updateTo?: number }) {
  const [errorCounterState, setErrorCounterState] = React.useState<number>();
  const toRef = React.useRef<number>();
  const gameCtx = React.useContext(GameContext);
  const theme = gameCtx.getTheme();
  const { t } = useTranslation();

  React.useEffect(() => {
    window.clearTimeout(toRef.current);
    toRef.current = window.setTimeout(() => {
      setErrorCounterState(errors);
    }, updateTo * 1000);
  }, [errors, updateTo]);

  return (
    <section className="ErrorBarComponent">
      <div className="errorBarsCont">
        {(() => {
          let res: JSX.Element[] = [];
          for (let i = 1; i <= gameCtx.getPreset().maxWrongQuestions - 1; i++) {
            res.push(
              <span
                key={i}
                className={'error' + (errorCounterState >= i ? ' error--filled' : '')}
                style={
                  errorCounterState >= i
                    ? { backgroundColor: theme.main[1], borderColor: theme.main[1] }
                    : { backgroundColor: theme.variants[0][0], borderColor: theme.variants[0][0] }
                }
              ></span>
            );
          }
          return res;
        })()}
        <span
          className={
            'error errorRight' +
            (errorCounterState >= gameCtx.getPreset().maxWrongQuestions ? ' error--filled' : '')
          }
          style={
            errorCounterState >= gameCtx.getPreset().maxWrongQuestions
              ? { backgroundColor: theme.main[1], borderColor: theme.main[1] }
              : { backgroundColor: theme.variants[0][0], borderColor: theme.variants[0][0] }
          }
        ></span>
      </div>
      <div className="label">
        {(t('game.errors') || '')
          .replace('§dE§', (errorCounterState ?? '').toString())
          .replace('§tE§', (gameCtx.getPreset().maxWrongQuestions).toString())
          .replace('§vocal§', errorCounterState === 1 ? 'e' : 'i')}
      </div>
    </section>
  );
}
